const skipKeys = ["ColorZone2__HIDDEN"];

const keyOverrides = {
  noPersonalization: "playerName",
  "Hand (aka curve or handedness)": "Hand",
  Pattern: "BladePattern",
  colorZone1: "ColorZone1",
  colorZone2: "ColorZone2",
  PlayerName: null,

  // Goalie Stick
  "Shaft Color code": "ShaftColor",
  "Bauer Logo Color code": "BauerLogoColor",
  "Flylite Logo Color code": "FlyliteLogoColor",
  "Paddle Color code": "PaddleColor",
  "Outline Color code": "OutlineColor",
  "Shoulder Color code": "ShoulderColor",
  "Shoulder Decal Color code": "ShoulderDecalColor",
  "Spine Color code": "SpineColor",
  "Shoulder (aka Handle, paddle shape)": "Shoulder",
  "Logos Color code": "LogosColor",
};

const valueOverrides = {
  noPersonalization: { value: true, valueOverride: null },
};

const overrideValue = ({ key, value }) => {
  if (valueOverrides[key] && value === valueOverrides[key].value) {
    return valueOverrides[key].valueOverride;
  }
  return value;
};

export default function getAnalyticsCustomConfigId({ userChoiceValues }) {
  const configIdParts = [];

  for (const [key, value] of Object.entries(userChoiceValues)) {
    if (skipKeys.includes(key)) continue;
    if (value) {
      const formattedValue = overrideValue({ key, value });
      const formattedKey =
        keyOverrides[key] ||
        key
          .replace(/\s+(.)/g, (_, char) => char.toUpperCase())
          .replace(/\s+/g, "");

      configIdParts.push(`${formattedKey}:${formattedValue}`);
    }
  }

  return configIdParts.join("|");
}
